<template>
  <v-app>
    <v-main>

      <router-view/>

      <div v-if="!store.customer.isLoggedIn && showAssociese" id="banner-associese">
        <div>
          <p>AINDA NÃO FAZ PARTE DO&nbsp;<strong>CLUBE OPUS?</strong></p>
          <Button buttonText="associe-se" @click="router.push('/facaparte')" />
        </div>
        <v-icon class="icon-close text-white" @click="showAssociese = false">mdi-close-box-outline</v-icon>
      </div>

    </v-main>
  </v-app>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/stores';
import Button from '@/components/Button.vue'

const router = useRouter();
const store = useStore();
const showAssociese = ref(true);
</script>

<style lang="scss">
  * {
    font-family: 'Poppins', Helvetica, Arial, sans-serif;
    font-weight: 600;
  }
  body {
    margin: 0
  }
  .navbar-filler {
    min-height: 80px;
  }
  .view-bg {
    background-color: $verde-opus;
  }
  .view-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 80px 8% 150px 8%;
    background-color: #e8e4e1;
    min-height:500px;
    h1 {
      margin-bottom: 20px;
      font-size: 32px;
      text-align:left;
    }
  }
  p {
    color: rgb(119, 119, 119);
    font-size: 16px;
    margin-bottom: 10px;
  }
  .gap-5px {
    gap: 5px;
  }
  .gap-10px {
    gap: 10px;
  }
  @media (max-width: 767px) {
    .view-content {
      padding: 30px 3% 50px 3%;
      h1 {
        margin-bottom: 10px;
      }
    }
  }

  #banner-associese {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width:100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8%;
    background-color: $verde-opus;
    z-index: 100;
  }
  #banner-associese > div {
    width:50%;
    margin: 0 auto;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 767px) {
      width:100%;
      font-size:10px;
    }
  }
  #banner-associese p {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    color: white;
    font-weight:400;
  }


</style>